import { Mutations } from "vuex-smart-module";
import { MutationTypes } from "../mutations-types";
import MapState from "./state";
import { IMeasurementPoint } from "./models";
import { latLng, LatLngBounds } from "leaflet";
import { Position } from "geojson";

export default class MapMutations extends Mutations<MapState> {
  [MutationTypes.SET_MAPCENTER](coords: Position) {
    this.state.mapCenter = latLng(coords[1], coords[0]);
  }
  [MutationTypes.UPDATE_ZOOM](zoom: number) {
    this.state.mapZoom = zoom;
  }
  [MutationTypes.SET_TARGETS_TAG_ZOOM](zoom: number) {
    this.state.targetsTagsZoomLevel = zoom;
  }
  [MutationTypes.SET_PLATFORMS_TAG_ZOOM](zoom: number) {
    this.state.platformsTagsZoomLevel = zoom;
  }
  [MutationTypes.UPDATE_BBOX](bbox: LatLngBounds) {
    this.state.bbox = bbox;
  }
  [MutationTypes.SELECT_BASELAYER](layer: string) {
    this.state.baseLayer = layer;
  }
  [MutationTypes.SELECT_FEATURES](feature: string[]) {
    this.state.selectedFeatures = feature;
  }
  [MutationTypes.SELECT_TARGETS](target: string[]) {
    this.state.selectedTargets = target;
  }
  [MutationTypes.ACTIVATE_MEASUREMENT]() {
    this.state.measurementActivated = !this.state.measurementActivated;
  }
  [MutationTypes.CHANGE_MEASUREMENTS_UNITS]() {
    this.state.measurementNauticalUnits = !this.state.measurementNauticalUnits;
  }
  [MutationTypes.ADD_MEASUREMENT_POINT](point: IMeasurementPoint) {
    this.state.measurementPoints.push(point);
  }
  [MutationTypes.CLEAR_MEASUREMENT]() {
    this.state.measurementPoints = [];
    this.state.totalDistance = 0;
  }
  [MutationTypes.UPDATE_TOTAL_DISTANCE](distance: number) {
    this.state.totalDistance = distance;
  }
}
